<form
    fsForm
    [submit]="save"
    *fsSkeleton="project">
  <fs-dialog>
    <h1 mat-dialog-title>
      Create Project
    </h1>
    <mat-dialog-content>
      <div class="fs-column">
        <mat-form-field>
          <mat-label>
            Name
          </mat-label>
          <input
            matInput
            [(ngModel)]="project.name"
            fsFormRequired
            name="name"
            (ngModelChange)="nameChanged()">
        </mat-form-field>
        <app-status-menu
          class="project"
          width="100%"
          [initOnClick]="false"
          [status]="project.status"
          [assignDefaultStatus]="true"
          (statusChanged)="statusChanged($event)">
        </app-status-menu>
        <mat-form-field #abr>
          <mat-label>
            Abbreviation
          </mat-label>
          <input
            matInput
            [(ngModel)]="project.abr"
            name="abr"
            (keyup)="abrKeyup($event)"
            fsFormRequired
            maxlength="3">
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button
          type="submit"
          mat-button
          color="primary">
        {{ project.id ? 'Save' : 'Create' }}
      </button>
      <button
          mat-button
          type="button"
          mat-dialog-close>
        Cancel
      </button>
    </mat-dialog-actions>
  </fs-dialog>
</form>